import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';

import { Box, Chip } from '@mui/material';

import { getStateNameById } from '../../config';

export interface AgencyStatusBadgeProps {
  state: AppNS.CompanyState;
}

const CLASSES: Record<AppNS.CompanyState, string> = {
  draft: 'outlined-gray',
  pending: 'warning flat',
  unpublished: 'warning flat',
  certified: 'success-outlined flat',
  deactivated: 'error-outlined flat',
  removed: 'error-outlined flat',
  suspended: 'error-outlined flat',
};

const getClass = (state: AppNS.CompanyState): string => {
  return CLASSES[state] || 'outlined-gray';
};

export default function AgencyStatusBadge(props: AgencyStatusBadgeProps) {
  const { state } = props;

  const agencyState = state || 'draft';

  return (
    <Box display="flex" alignItems="center" gap={1} mt={-0.5}>
      {agencyState === 'certified' && (
        <Box
          component="img"
          sx={{ display: 'block', mt: 0.5 }}
          src={assetUrl('/images/badges/valid.svg')}
          alt="Certified"
          width="38"
        />
      )}
      <Chip clickable={false} className={getClass(agencyState)} label={getStateNameById(agencyState)} />
    </Box>
  );
}
